import React from 'react';
import ReactExport from 'react-data-export';
import formatSeconds from './TimeFormat';
import '../../views/ServiceReport.css';
import '../forms/Button.css';

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

// A bit hackish way to get overall results.
const addOverallValues = (tasks) => {
  // copy
  const tasksWithOverallValues = tasks.slice(0);

  // calculate overall values
  let overallSeconds = 0;
  let overallPrice = 0;
  for (let i = 0; i < tasks.length; i += 1) {
    const task = tasks[i];
    overallSeconds += task.totalDuration;
    overallPrice += Number(task.invoicePrice);
  }

  // create overall values
  tasksWithOverallValues.push({
    totalDuration: overallSeconds,
    customer: {},
    invoicePrice: overallPrice,
  });
  return tasksWithOverallValues;
};

const ExportExcelButton = ({ translate, data, isAdmin }) => {
  if (isAdmin) {
    const durationLabel = `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.timeFormat')})`;
    const durationSecLabel = `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.secFormat')})`;
    const tasksWithOverallValues = addOverallValues(data);
    return (
      <ExcelFile hideElement filename={translate('service_report.search.type_task')}>
        <ExcelSheet data={tasksWithOverallValues} name="Sheet1">
          <ExcelColumn label={translate('service_report.column_task.date')} value="localizedEndDate" />
          <ExcelColumn label={durationLabel} value={(col) => formatSeconds(col.totalDuration)} />
          <ExcelColumn label={durationSecLabel} value={(col) => col.totalDuration} />
          <ExcelColumn label={translate('service_report.column_task.customer')} value={(col) => col.customer.name} />
          <ExcelColumn label={translate('service_report.column_task.end_customer')} value="companyName" />
          <ExcelColumn label={translate('service_report.column_task.address')} value="streetAddress" />
          <ExcelColumn label={translate('service_report.column_task.city')} value="city" />
          <ExcelColumn label={translate('service_report.column_task.service_site')} value="serviceSiteNo" />
          <ExcelColumn label={translate('service_report.column_task.service')} value="localizedServiceName" />
          <ExcelColumn label={translate('service_report.column_task.feature')} value={(col) => col.additionalFeatures == null ? null : col.additionalFeatures.join(', ')} />
          <ExcelColumn label={translate('service_report.column_task.amount')} value="invoicePrice" />
          <ExcelColumn label={translate('service_report.column_task.user')} value="userId" />
          <ExcelColumn label={translate('service_report.column_task.additional_info')} value="parsedInfo" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  return (
    <ExcelFile hideElement filename={translate('service_report.search.type_task')}>
      <ExcelSheet data={data} name="Sheet1">
        <ExcelColumn label={translate('service_report.column_task.date')} value="localizedEndDate" />
        <ExcelColumn label={translate('service_report.column_task.customer')} value={(col) => col.customer.name} />
        <ExcelColumn label={translate('service_report.column_task.terminal')} value="companyName" />
        <ExcelColumn label={translate('service_report.column_task.address')} value="streetAddress" />
        <ExcelColumn label={translate('service_report.column_task.city')} value="city" />
        <ExcelColumn label={translate('service_report.column_task.service_site')} value="serviceSiteNo" />
        <ExcelColumn label={translate('service_report.column_task.service')} value="localizedServiceName" />
        <ExcelColumn label={translate('service_report.column_task.amount')} value="invoicePrice" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportExcelButton;



// WEBPACK FOOTER //
// ./src/components/servicereport/ExportExcelButton.jsx